import { render, staticRenderFns } from "./DataGatheringHeader.vue?vue&type=template&id=058711d1&"
import script from "./DataGatheringHeader.vue?vue&type=script&lang=js&"
export * from "./DataGatheringHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports